import merge from 'deepmerge';

import de from './de/common.json';
import deAT from './de-AT/common.json';
import deCH from './de-CH/common.json';
import en from './en/common.json';
import fr from './fr/common.json';
import frCH from './fr-CH/common.json';

const common = {
  fr: fr.common,
  en: en.common,
  de: de.common,
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'fr-CH': merge(fr.common, frCH.common || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-CH': merge(de.common, deCH.common || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-AT': merge(de.common, deAT.common || {}),
};

export default common;
